var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 6,
    fill: "#00BAC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9408 20.1608L16.2727 45.9368C15.9703 46.4881 15.8103 47.1131 15.8086 47.7497C15.8069 48.3863 15.9636 49.0123 16.2631 49.5654C16.5626 50.1184 16.9944 50.5793 17.5156 50.9022C18.0369 51.225 18.6293 51.3986 19.2341 51.4056H48.5703C49.175 51.3986 49.7675 51.225 50.2887 50.9022C50.8099 50.5793 51.2418 50.1184 51.5412 49.5654C51.8407 49.0123 51.9974 48.3863 51.9957 47.7497C51.994 47.1131 51.834 46.4881 51.5316 45.9368L36.8635 20.1608C36.5548 19.625 36.1201 19.1821 35.6014 18.8747C35.0827 18.5673 34.4974 18.4058 33.9022 18.4058C33.3069 18.4058 32.7217 18.5673 32.203 18.8747C31.6842 19.1821 31.2496 19.625 30.9408 20.1608Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9062 29.5308V36.8224",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9062 44.1143H33.9236",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTask);
export default __webpack_public_path__ + "static/media/pendingTask.f67727a348e2cf567da969b2f4c44b2f.svg";
export { ForwardRef as ReactComponent };